const InvoiceDashboard = ({ title, users = [] }) => {
  return (
    <div className="upcoming-book h-100">
      <div className="d-flex justify-content-between align-items-center upcoming-head pad-head">
        <h6>{title}</h6>
      </div>

      <div className="d-flex justify-content-between align-items-center employeesec">
        <div className="carousel-sec">
          {users.length > 0 ? (
            users.map((user) => (
              <div className="dashboardimg" key={user?.user_id}>
                <h6>
                  <span className="dashboard-recent-main">{user?.name}</span>
                  <span className="dashboard-recent-meta">{user?.invoice_count}</span>
                </h6>
              </div>
            ))
          ) : (
            <div className="dashboard-empty-state">No records found</div>
          )}
        </div>
      </div>
    </div>
  );
};

export default InvoiceDashboard;
